export default __webpack_public_path__ + "static/media/dp.e97d0509.png";